import { call, put } from 'typed-redux-saga'
import { clearRedirectWindowApplicantId } from '../../actions/redirectWindowActions'
import * as bankLoginActions from '../../actions/consumerDataPullSessionActions/bankLoginActions'
import { transactionApiClient } from '../../../../../api/transactionApiClient'

export function* createBankLoginUrlSaga(action: {
	type: 'CREATE_BANK_LOGIN_URL'
	bankId: number
	ssn?: string
}): Generator {
	try {
		yield put(bankLoginActions.clearErrors())
		const bankLoginUrlDto = yield* call(
			transactionApiClient.createBankLoginUrl,
			action.bankId,
			action.ssn,
		)
		yield put(bankLoginActions.createBankLoginUrlSucceeded(bankLoginUrlDto))
	} catch (error: any) {
		yield put(bankLoginActions.createBankLoginUrlFailed(error))
	}
}

export function* clearStateSaga(): Generator {
	yield put(clearRedirectWindowApplicantId())
}
